import * as React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { variables } from "../Variables";
import { addNewActionsLog, getEstateStatusFromInDB } from "../utils/commonService";
import { getEstateAndOfficeSettingAgentsite, updateParentActionLog } from "../services/commonService";
import { ContactWaitingListModel } from "../components/ContactWaitingListModel";
import { ConfirmDeleteWindow } from "../components/ConfirmDeleteWindow";
import { EstateJobActionModel } from "./EstateJobActionModel";
import { dumpWhiseEventsOnEstateActivationService, getEstateStatusListFromDBservice, updateEstateStatusInDBService } from "../services/EstateLogicService";
import { deleteEstateFreeSlotEventsFromDB } from "../services/DeleteEstateAllFreeSlotEventsFromDBService";
import { getStartingNumber } from "../utils/validate";

import { setActiveEstateList } from "../features/ActiveEstateList";
import { setFetchLatestRecordStatus } from "../features/FetchLatestRecordSlice";
import { setEstateStatusList } from "../features/EstateStatusListSlice";
import { ConfirmDeleteModel } from "../eventforms/ConfimrDeleteModal";
import { setShowEditEstateConfigModal } from "../features/ShowEditEstateConfigModal";
import { setShowWaitingAndEventsModal } from "../features/ShowWaitingAndEventsModal";
import { setShowHistoryTabModal } from "../features/ShowHistoryTabSlice";
import { HistoryTabModal } from "./HistoryTabModal";

export const EstateActionListMenu = ({ estate, identity, showMessage, setShowCalendarLoader, getWhiseCalenderEvents,
    historyActionLogsCount, estateJobActionStatusBtn, setEstateJobStatusBtn, reduxCalendarView  }) => {

    const user = useSelector(state => state.user.user);
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxActiveEstateList = useSelector(state => state.activeEstateList.activeEstateList);
    const reduxFetchLatestRecord = useSelector(state => state.fetchLatestRecord.fetchLatestRecord);
    const reduxallEstatesList = useSelector(state => state.allEstatesList.allEstatesList);
    const reduxClientSetting = useSelector(state => state.setting.setting);
    const reduxEstateStatusList = useSelector(state => state.estateStatusList.estateStatusList);
    const reduxWaitingListEnabled = useSelector(state => state.waitingListEnabled.waitingListEnabled);
    const reduxRenderApp = useSelector(state => state.renderApp.renderApp);

    console.log(estateJobActionStatusBtn);
    console.log(reduxClientSetting);
    //console.log(reduxallEstatesList);
    const dispatch = useDispatch();

    //const [estateJobStatusBtn, setEstateJobStatusBtn] = useState(null);
    const [estateStatusListFromDB, setEstateStatusListFromDB] = useState(null); //{}

    const [confirmWindowMessage, setConfirmWindowMessage] = useState("Do you want to delete past free slots?");
    const [confirmationFreeSlotDeletModel, setConfirmationFreeSlotDeletModel] = useState(false);
    const [currentEstateId, setCurrentEstateId] = useState(null);


    // estate job action model 
    const [showEstateJobActionModel, setShowEstateJobActionModel] = useState(false);
    const [refreshBtnStatus, setRefreshBtnStatus] = useState(0);

    // delete free slots
    const [showConfirmModel, setShowConfirmModel] = useState(false);
    const [isBtnLoading, setIsBtnLoading] = useState(true);

    const getEstatePurposeConfigJobStatusBtn = async (estateId) => {
        try {
            setIsBtnLoading(true);
            let url = `${variables.API_URL}LocalEvents/GetEstatePurposeConfigIdentification?estateId=${estateId}`;

            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig);

            if (response.data != undefined) {
                
                setEstateJobStatusBtn(response.data[0]);
                //return response.data;
                //setIsBtnLoading(false);
            }
        } catch (error) {
            console.log(error);
            setIsBtnLoading(false);
        }
    }

    //useEffect(() => {
    //    if (estate?.id) {
    //        setIsBtnLoading(true);
    //        getEstatePurposeConfigJobStatusBtn(estate.id);
    //    }
    //}, [estate, refreshBtnStatus, reduxRenderApp]);


    const getEstateStatusListFromDB = async (allEstates) => {

        try {
            const url = `${variables.API_URL}LocalEvents/GetBulkEstateStatus`;

            const config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            }

            //const getAllEstateIds = allEstates.map(itemEstate => itemEstate.id);

            const body = {
                clientId: estate.clientId,
                estateIds: allEstates
            }

            const response = await axios.post(url, body, config);
            if (response.data) {
                dispatch(setEstateStatusList(response.data));
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        // Treat both null and empty object {} as "not loaded yet"
        const isEstateStatusListEmpty =
            reduxEstateStatusList == null ||
            (typeof reduxEstateStatusList === "object" && Object.keys(reduxEstateStatusList).length === 0);

        if (isEstateStatusListEmpty && reduxActiveEstateList) {
            getEstateStatusListFromDB(reduxActiveEstateList);
        }
    }, [reduxActiveEstateList]);

    // copy estate url
    const copyBookingUrl = (estatId) => {
        const url = `${variables.Booking_URL}${estatId}`;
        navigator.clipboard.writeText(url);
    }

    // estate active
    const markEstateActiveInDB = async (estate) => {
        try {
            setShowCalendarLoader(true);
            let url = variables.API_URL + "Estate/ActivateEstateInDB?";
            const config = {
                headers: {
                    'Authorization': `Bearer ${user.tokenValue}`,
                    'Content-Type': 'application/json'
                },
            };

            if (identity === "property") {
                estate.category = estate.categoryId ? { id: estate.categoryId } : null;
                estate.subCategory = estate.subcategoryId ? { id: estate.subcategoryId } : null;
                estate.country = estate.countryId ? { id: estate.countryId } : null;
                estate.status = estate.statusId ? { id: estate.statusId } : null;
                estate.purpose = estate.purposeId ? { id: estate.purposeId } : null;
                estate.purposeStatus = estate.purposeStatusId ? { id: estate.purposeStatusId } : null;
                estate.state = estate.statusId ? { id: estate.statusId } : null;
                estate.pictures = estate.urlSmall ? [{ urlSmall: estate.urlSmall }] : [];
                estate.displayStatusId = estate.estateDisplayStatusId ? estate.estateDisplayStatusId : null;
            }

            // get estate status from db
            const previousEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

            const response = await axios.post(url, estate, config); // replace body => estate

            if (response.status === 200) {

                // check active estate in db and dump in redux store
                const checkIsEstateAlreadyExistInDB = reduxActiveEstateList.includes(estate.id);
                const updateActiveEstateList = checkIsEstateAlreadyExistInDB ? reduxActiveEstateList : reduxActiveEstateList.concat([estate.id]);
                dispatch(setActiveEstateList(updateActiveEstateList));

                // latest get all estate status
                const getEstateStatusList = await getEstateStatusListFromDBservice(reduxallEstatesList);
                dispatch(setEstateStatusList(getEstateStatusList));

                let estateActionList = [reduxClientSetting.visitToSaleFreeSlot, reduxClientSetting.visitToRentFreeSlot, reduxClientSetting.visitToSaleBefore, reduxClientSetting.visitToRentBefore, reduxClientSetting.visitToSaleAfter, reduxClientSetting.visitToRentAfter,]

                let calendarActionList = [...new Set(estateActionList)];

                const dumpWhiseEventApiObj = {
                    estateId: estate.id,
                    activeEstateList: updateActiveEstateList,
                    clientId: estate.clientId,
                    estateCalendarActionList: calendarActionList,
                }

                // Await the inner async call and catch any errors
                await dumpWhiseEventsOnEstateActivationService(dumpWhiseEventApiObj, user.tokenValue);

                showMessage("success", response.data);
             
                await getEstatePurposeConfigJobStatusBtn(estate.id);

                setRefreshBtnStatus(prev => prev + 1); // render latest button status

                // render latest record
                if (identity === "calendar") {
                    dispatch(setFetchLatestRecordStatus(true)); // render latest record
                } else if (identity === "property") {
                    getWhiseCalenderEvents(); // render latest estate record
                }

                setShowCalendarLoader(false);

                // get estate status from db
                const newEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

                // object action log
                const actionLogObj = {
                    actionId: 1,
                    actionStatus: true,
                    estateId: +estate.id,
                    clientId: +estate.clientId,
                    metadata: JSON.stringify({
                        "previousSmartCalendarStatus": false,
                        "oldEstateStatus": `${previousEstateStatus}`,
                        "newSmartCalendarStatus": true,
                        "newEstateStatus": `${newEstateStatus}`,
                        "description": `Estate status is active`,
                        "key": `Estate Active`
                    }),
                    performedBy: "agent",
                    parentLogId: null,
                    syncWithWhise: null, //reduxClientSetting.syncEventsToWhise,
                    origin: "",
                    exception: null
                }

                //console.log(actionLogObj);

                // add action log
                addNewActionsLog(actionLogObj);
            } else {
                showMessage("error", "Unexpected response from server.");
                setShowCalendarLoader(false);

                //get estate status from db
                const previousEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

                // object action log
                const actionLogObj = {
                    actionId: 1,
                    actionStatus: false,
                    estateId: +estate.id,
                    clientId: +estate.clientId,
                    metadata: JSON.stringify({
                        "previousSmartCalendarStatus": false,
                        "oldEstateStatus": `${previousEstateStatus}`,
                        "newSmartCalendarStatus": true,
                        "newEstateStatus": "",
                        "description": `Estate status is active`,
                        "key": `Estate Active`
                    }),
                    performedBy: "agent",
                    parentLogId: null,
                    syncWithWhise: null, //reduxClientSetting.syncEventsToWhise,
                    origin: "",
                    exception: "Unexpected response from server."
                }

                // add action log
                addNewActionsLog(actionLogObj);
            }
        } catch (error) {
            showMessage("error", "Error activating estate: " + error.message);
            setShowCalendarLoader(false);

            //get estate status from db
            const previousEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

            // object action log
            const actionLogObj = {
                actionId: 1,
                actionStatus: false,
                estateId: +estate.id,
                clientId: +estate.clientId,
                metadata: JSON.stringify({
                    "previousSmartCalendarStatus": false,
                    "oldEstateStatus": `${previousEstateStatus}`,
                    "newSmartCalendarStatus": false,
                    "newEstateStatus": "",
                    "description": `Estate status is active`,
                    "key": `Estate Active`
                }),
                performedBy: "agent",
                parentLogId: null,
                syncWithWhise: reduxClientSetting.syncEventsToWhise,
                origin: "",
                exception: `${JSON.stringify(error)}`
            }

            // add action log
            addNewActionsLog(actionLogObj);
        }
    }

    // estate deactive
    const markEstateDeactiveInDB = async (estate) => {
        setShowCalendarLoader(true);
        try {
            let url = variables.API_URL + `Estate/DeactivateEstateInDB?estateId=${estate.id}`;
            const config = {
                headers: {
                    'Authorization': `Bearer ${user.tokenValue}`,
                    'Content-Type': 'application/json'
                },
            };

            let body = {}

            // get estate status from db
            const previousEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

            const response = await axios.post(url, body, config);

            if (response.status === 200) {


                // remove deactiveEstateId form activeEstateList
                let removeSelectEstateFromActiveList = reduxActiveEstateList.filter(item => item != estate.id);
                dispatch(setActiveEstateList(removeSelectEstateFromActiveList));

                // latest get all estate status
                const getEstateStatusList = await getEstateStatusListFromDBservice(reduxallEstatesList);
                dispatch(setEstateStatusList(getEstateStatusList));
                
                await getEstatePurposeConfigJobStatusBtn(estate.id);

                // latest get all estate status
                showMessage("success", response.data);

                setRefreshBtnStatus(prev => prev + 1);

                // render latest record
                if (identity === "calendar") {
                    dispatch(setFetchLatestRecordStatus(true)); // render calendar.js latest record
                } else if (identity === "property") {
                    getWhiseCalenderEvents(); // render latest estate record
                }

                setShowCalendarLoader(false);

                // get estate status from db
                const newEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

                // object action log
                const actionLogObj = {
                    actionId: 1,
                    actionStatus: true,
                    estateId: estate.id,
                    clientId: +estate.clientId,
                    metadata: JSON.stringify({
                        "previousSmartCalendarStatus": true,
                        "oldEstateStatus": `${previousEstateStatus}`,
                        "newSmartCalendarStatus": false,
                        "newEstateStatus": `${newEstateStatus}`,
                        "description": `Estate status is deactivate`,
                        "key": `Estate deactivate`

                    }),
                    performedBy: "agent",
                    parentLogId: null,
                    syncWithWhise: null, //reduxClientSetting.syncEventsToWhise,
                    origin: "",
                    exception: null
                }

                // add action log
                addNewActionsLog(actionLogObj);

            } else {
                showMessage("error", "Unexpected response from server.");
                setShowCalendarLoader(false);

                //// object action log
                const actionLogObj = {
                    actionId: 1,
                    actionStatus: false,
                    estateId: estate.id,
                    clientId: +estate.clientId,
                    metadata: JSON.stringify({
                        "previousSmartCalendarStatus": true,
                        "oldEstateStatus": `${previousEstateStatus}`,
                        "newSmartCalendarStatus": false,
                        "newEstateStatus": "",
                        "description": `Estate status is deactivate`,
                        "key": `Estate deactivate`
                    }),
                    performedBy: "agent",
                    parentLogId: null,
                    syncWithWhise: null, //reduxClientSetting.syncEventsToWhise,
                    origin: "",
                    exception: "Unexpected response from server."
                }

                // add action log
                addNewActionsLog(actionLogObj);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            setShowCalendarLoader(false);
            showMessage("error", error);

            // get estate status from db
            const previousEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

            // object action log
            const actionLogObj = {
                actionId: 1,
                actionStatus: false,
                estateId: +estate.id,
                clientId: +estate.clientId,
                metadata: JSON.stringify({
                    "previousSmartCalendarStatus": true,
                    "oldEstateStatus": `${previousEstateStatus}`,
                    "newSmartCalendarStatus": false,
                    "newEstateStatus": "",
                    "description": `Estate status is deactivate`,
                    "key": `Estate deactivate`
                }),
                performedBy: "agent",
                parentLogId: null,
                syncWithWhise: reduxClientSetting.syncEventsToWhise,
                origin: "",
                exception: `${JSON.stringify(error)}`
            }

            // add action log
            addNewActionsLog(actionLogObj);
        }
    }

    const handlerConfirmationAllFreeSlotDeleteModelOpen = (event, estateId) => {
        setConfirmWindowMessage(reduxLanguageTranslations ? reduxLanguageTranslations["eventDeleteWindowModalYouWantDeleteEventPastFreeSlots"] : "Do you want to delete past free slots?");
        setShowConfirmModel(event);
        setCurrentEstateId(estateId);
    }

    // delete all free slots
    useEffect(() => {

        if (confirmationFreeSlotDeletModel && showConfirmModel && currentEstateId) {

            const handleDelete = async () => {

                // Now await works fine
                const previousEstateStatus = await getEstateStatusFromInDB(currentEstateId, estate.clientId);

                setShowCalendarLoader(true);

                let url = variables.API_URL + `calendar/DeleteEstateFreeSlots?clientId=${estate.clientId}&estateId=${currentEstateId}`;

                const config = {
                    headers: {
                        'Authorization': `Bearer ${user.tokenValue}`,
                        'Content-Type': 'application/json'
                    },
                };

                axios.post(url, {}, config)
                    .then(async response => {
                        if (response.status == 200) {
                            let _delDbFreeSlotResponse;
                            try {
                                _delDbFreeSlotResponse = await deleteEstateFreeSlotEventsFromDB(estate.clientId, currentEstateId);
                                console.log(_delDbFreeSlotResponse);
                            } catch (dbError) {
                                // latest get all estate status
                                setShowCalendarLoader(false);
                                console.error('Error deleting calendar events from DB:');
                                showMessage("error", dbError);

                                // add logs
                                const newEstateStatus = await getEstateStatusFromInDB(currentEstateId, estate.clientId);

                                const actionLogObj = {
                                    estateId: +currentEstateId,
                                    clientId: +estate.clientId,
                                    actionId: 4,
                                    actionStatus: false,
                                    metadata: JSON.stringify({
                                        oldEstateStatus: previousEstateStatus,
                                        newEstateStatus: newEstateStatus,
                                        description: `Free slot DB delete failed`,
                                        key: "Delete free slots"
                                    }),
                                    performedBy: "agent",
                                    parentLogId: null,
                                    syncWithWhise: reduxClientSetting.syncEventsToWhise,
                                    origin: "",
                                    exception: `${JSON.stringify(dbError)}`
                                };
                                addNewActionsLog(actionLogObj);
                                return;
                            }

                            // latest get all estate status
                            showMessage("success", response.data);

                            // update estate status
                            await updateEstateStatusInDBService(currentEstateId, estate.clientId);

                            // latest get all estate status
                            const getEstateStatusList = await getEstateStatusListFromDBservice(reduxallEstatesList);
                            dispatch(setEstateStatusList(getEstateStatusList));

                            if (identity === "calendar") {
                                // get latest events and estate from whise and local db
                                getWhiseCalenderEvents("onAction", reduxCalendarView.startDate, reduxCalendarView.endDate, reduxCalendarView.view);
                            } else if (identity === "property") {
                                getWhiseCalenderEvents(); // render latest estate record
                            }

                            setShowCalendarLoader(false);

                            // get new estate status
                            const newEstateStatus = await getEstateStatusFromInDB(currentEstateId, estate.clientId);

                            // delete free slots count
                            const freeSlotDeleteCount = getStartingNumber(_delDbFreeSlotResponse);

                            // add action log
                            let actionLogObj = {
                                estateId: +currentEstateId,
                                clientId: +estate.clientId,
                                actionId: 4,
                                actionStatus: true,
                                metadata: JSON.stringify({
                                    oldEstateStatus: previousEstateStatus,
                                    newEstateStatus: newEstateStatus,
                                    freeslotDeleteCount: freeSlotDeleteCount,
                                    description: `${freeSlotDeleteCount} free slot is deleted`,
                                    key: "Delete free slots"
                                }),
                                performedBy: "agent",
                                parentLogId: null,
                                syncWithWhise: reduxClientSetting.syncEventsToWhise,
                                origin: "",
                                exception: null
                            };

                            const addNewLog = await addNewActionsLog(actionLogObj); // action log

                            // property status change
                            actionLogObj.parentLogId = addNewLog.logId;
                            actionLogObj.actionId = 1;
                            actionLogObj.syncWithWhise = null;
                            actionLogObj.performedBy = "system";
                            actionLogObj.origin = "Free Slots Deletion";

                            await addNewActionsLog(actionLogObj); // action log

                            //updateParentActionLog({ parentLogId: addNewLog.logId, metadata: addNewLog.metaData, exception: null });
                        }
                    })
                    .catch(async (error) => {
                        console.error('Error deleting free slots:', error);
                        setShowCalendarLoader(false);
                        showMessage("error", error);

                        // get new estate status
                        const newEstateStatus = await getEstateStatusFromInDB(currentEstateId, estate.clientId);

                        // action log
                        let actionLogObj = {
                            estateId: +currentEstateId,
                            clientId: +estate.clientId,
                            actionId: 4,
                            actionStatus: false,
                            metaData: JSON.stringify({
                                oldEstateStatus: previousEstateStatus,
                                newEstateStatus: newEstateStatus,
                                description: `Free slot is not deleted`
                            }),
                            performedBy: "agent",
                            parentLogId: null,
                            syncWithWhise: reduxClientSetting.syncEventsToWhise,
                            origin: "",
                            exception: `${JSON.stringify(error)}`
                        };

                        addNewActionsLog(actionLogObj);
                    });
            };

            handleDelete();
            closeConfirmDeleteModel();
        }

    }, [confirmationFreeSlotDeletModel, currentEstateId]);

    // Estate Job action (on hold / deactivate)
    const openModelEstateJobActions = () => {
        setShowEstateJobActionModel(true);
    }

    const closeModelEstateJobActions = () => {
        setShowEstateJobActionModel(false);
    }

    // confirm modol close (Delete free slots)
    const closeConfirmDeleteModel = () => {
        setShowConfirmModel(false);
        setConfirmationFreeSlotDeletModel(false);
    }

    const confirmActionPerform = () => {
        setConfirmationFreeSlotDeletModel(true);
    }

    // open edit estate config modal (equestion/ documents)
    const handleEditEstateConfigModalOpen = () => {
        dispatch(setShowEditEstateConfigModal(true));
    }

    // open waiting and events record modal
    const handleOpenWaitingListAndEventsRecordModal = () => {
        dispatch(setShowWaitingAndEventsModal(true));
    }

    // show history tab modal
    const handlerShowHistoryTabModal = () => {
        //dispatch(setShowHistoryTabModal(true));
        dispatch(setShowHistoryTabModal({ show: true, estateId: estate.id }));
    }

    return (
        <>
            {
                //isBtnLoading ?
                //    <div className="text-center py-2">
                //        <span className="spinner-border spinner-border-sm" role="status" />
                //    </div>
                //    :
                    estateJobActionStatusBtn != null && estateJobActionStatusBtn.identification.toLowerCase() == "active" ?
                        <button className={`drop-menu-btn text-start`} onClick={() => markEstateActiveInDB(estate)}>{reduxLanguageTranslations ? reduxLanguageTranslations["activateEstateInDatabase"] : "Activate"}</button>
                        : estateJobActionStatusBtn != null && estateJobActionStatusBtn.identification.toLowerCase() == "deactivate" ?
                        //  <button className={`drop-menu-btn text-start`} onClick={estateJobActionStatusBtn != null && estateJobActionStatusBtn.jobProcessStatus ? () => markEstateDeactiveInDB(estate) : () => openModelEstateJobActions()}>{reduxLanguageTranslations ? reduxLanguageTranslations["deactivateEstateInDatabase"] : "Deactivate"}</button>
                        <button className={`drop-menu-btn text-start`} onClick={(estateJobActionStatusBtn != null && estateJobActionStatusBtn.jobProcessStatus == false) || (reduxClientSetting != null && reduxClientSetting.purposeStatusChangeSetting) ? () => openModelEstateJobActions() : () => markEstateDeactiveInDB(estate)}>{reduxLanguageTranslations ? reduxLanguageTranslations["deactivateEstateInDatabase"] : "Deactivate"}</button>
                            : estateJobActionStatusBtn != null && estateJobActionStatusBtn.identification.toLowerCase() == "onhold" ?
                                <button className={`drop-menu-btn text-start`} onClick={estateJobActionStatusBtn != null && estateJobActionStatusBtn.jobProcessStatus ? (e) => markEstateDeactiveInDB(estate) : () => openModelEstateJobActions()}>{reduxLanguageTranslations ? reduxLanguageTranslations["onHold"] : "OnHold"}</button>
                                :
                                <></>
            }
            <hr className={` ${reduxEstateStatusList?.[estate.id] == "Active" || (reduxEstateStatusList?.[estate.id] == "Pending" && reduxWaitingListEnabled) || (reduxEstateStatusList?.[estate.id]?.toLowerCase() == "onhold" && reduxWaitingListEnabled) ? "mx-2 my-0" : "d-none"}`} />
            <button className={`drop-menu-btn text-start ${reduxEstateStatusList?.[estate.id] == "Active" || (reduxEstateStatusList?.[estate.id] == "Pending" && reduxWaitingListEnabled) || (reduxEstateStatusList?.[estate.id]?.toLowerCase() == "onhold" && reduxWaitingListEnabled) ? "" : "d-none"}`} onClick={() => copyBookingUrl(estate.id)}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListCopyLink"] : "Copy booking link"}</button>
            <hr className={`${reduxEstateStatusList?.[estate.id] == "Active" ? "mx-2 my-0" : "d-none"}`} />
            <button className={`drop-menu-btn text-start ${reduxEstateStatusList?.[estate.id] == "Active" ? "" : "d-none"}`} onClick={() => handlerConfirmationAllFreeSlotDeleteModelOpen(!confirmationFreeSlotDeletModel, estate.id)}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListDeleteFreeSlot"] : "Delete all free slots"}</button>
            <hr className={`${identity === "property" ? "d-none" : "mx-2 my-0"}`} />
            <button className={`${identity === "property" ? "d-none" : "drop-menu-btn text-start"}`} onClick={handleEditEstateConfigModalOpen}>
                {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListEditForm"] : "Edit Form"}
            </button>
            <hr className={`mx-2 my-0`} />
            <button className={`drop-menu-btn text-start`} onClick={reduxWaitingListEnabled ? () => handleOpenWaitingListAndEventsRecordModal() : undefined}>
                {reduxWaitingListEnabled ? reduxLanguageTranslations ? reduxLanguageTranslations["showContactListBtn"] : "Contact list" : reduxLanguageTranslations ? reduxLanguageTranslations["noContact"] : "No Contact"}
            </button>
            <hr className={`${historyActionLogsCount?.data ? "mx-2 my-0" : "d-none" }`} />
            <button className={` ${historyActionLogsCount?.data ? "drop-menu-btn text-start" : "d-none" }`} onClick={handlerShowHistoryTabModal}>
                {reduxLanguageTranslations ? reduxLanguageTranslations["history"] : "History"}
            </button>
            
            <EstateJobActionModel
                showModel={showEstateJobActionModel}
                closeModel={closeModelEstateJobActions}
                clientId={estate.clientId}
                estate={estate}
                //officeId={estate.officeId}
                officeId={user.user.officeId}
            />

            <ConfirmDeleteModel
                showModel={showConfirmModel}
                closeModel={closeConfirmDeleteModel}
                displayMessage={confirmWindowMessage}
                confirmAction={confirmActionPerform}
            />

            <HistoryTabModal estate={estate} />
        </>
    );
};
